import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from '../../@types/redux';
import Dialog from '@material-ui/core/Dialog';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import { IUserSession } from '../../@types/employee';
import Tooltip from '@material-ui/core/Tooltip';
import PrimaryTabs from '../customComponents/tab/PrimaryTabs';
import PrimaryTab from '../customComponents/tab/PrimaryTab';
import PumpingStationFunctions from '../../store/pumpingStation/functions';
import { IPumpingStation } from '../../@types/model/pumpingStation/pumpingStation';
import TabViews from '../customComponents/tab/TabViews';
import PumpingStationSummary from './view/PumpingStationSummaryView';
import PumpingStationDivision from './view/PumpingStationDivisionView';
import PumpingStationLocation from './view/PumpingStationLocationView';
import PumpingStationConnections from './view/PumpingStationConnectionsView';
import PumpingStationAudit from './view/PumpingStationAuditsView';
import ConfirmDialog from '../customComponents/dialog/ConfirmDialog';
import { Transitions } from '../customComponents/animations/Transitions';
import PumpingStationInspectionAudit from './view/PumpingStationInspectionAuditView';
import PumpingStationTransformerView from './view/PumpingStationTransformerView';

interface IPumpingStationInfoProps {
    fullWidth ?: boolean;
    maxWidth ?: 'xs' | 'sm' | 'md' | 'lg' | false;
    fullScreen ?: boolean;
    transition ?: React.ForwardRefExoticComponent<TransitionProps & React.RefAttributes<unknown>>;

    pumpingStation ?: IPumpingStation | null;
    isLoadingPumpingStations : boolean;

    session ?: IUserSession | null;
}

interface IPumpingStationInfoState {
    tabIndex : number;
    showDelete : boolean;
}

class PumpingStationInfo extends React.PureComponent<IPumpingStationInfoProps, IPumpingStationInfoState> {
    constructor(props : IPumpingStationInfoProps) {
        super(props);

        this.state = {
            tabIndex: 0,
            showDelete: false,
        };
    }

    private onClose = () => {
        PumpingStationFunctions.setSelected();
    };

    private onTabChange = (event : React.ChangeEvent<unknown>, value : number) => {
        this.setState({
            tabIndex: value,
        });
    };

    private onDeleteClick = () => {
        this.setState({
            showDelete: true,
        });
    };

    private onDelete = (result : boolean) => {
        if (result && this.props.pumpingStation && (typeof this.props.pumpingStation.isActive === 'undefined' || this.props.pumpingStation.isActive)) {
            PumpingStationFunctions.deactivate(this.props.pumpingStation);
        } else if (result && this.props.pumpingStation && !this.props.pumpingStation.isActive) {
            PumpingStationFunctions.activate(this.props.pumpingStation);
        }

        this.setState({
            showDelete: false,
        });
    };

    public render = () => {
        const { pumpingStation, fullWidth, transition, maxWidth, fullScreen, session, isLoadingPumpingStations } = this.props;
        const { tabIndex, showDelete } = this.state;
        return (
            <Dialog
                open={!!pumpingStation}
                onClose={this.onClose}
                aria-labelledby='pumpingStation-info-dialog-title'
                aria-describedby='pumpingStation-info-description'
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                TransitionComponent={transition}
                transitionDuration={500}
                fullScreen={fullScreen}>
                <AppBar className='posr' position='static' elevation={0}>
                    <Toolbar variant='dense'>
                        {
                            pumpingStation &&
                            <Typography variant='h6' color='inherit' className='flx1'>
                                {pumpingStation.code} - {pumpingStation.name}
                            </Typography>
                        }
                        <span className={'flx1'} />
                        {
                            !!session?.employee.IsPumpingStationAdmin && (
                                <Tooltip title={typeof pumpingStation?.isActive === 'undefined' || pumpingStation.isActive ? 'Deactivate' : 'Activate'}>
                                    <div>
                                        <IconButton color={'inherit'} onClick={this.onDeleteClick} aria-label={'Delete'} disabled={isLoadingPumpingStations}>
                                            <Icon>{typeof pumpingStation?.isActive === 'undefined' || pumpingStation.isActive ? 'delete' : 'check'}</Icon>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )
                        }
                        <Tooltip title='Close'>
                            <div>
                                <IconButton color='inherit' onClick={this.onClose} aria-label='Close'>
                                    <Icon>close</Icon>
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Toolbar>
                    <PrimaryTabs value={tabIndex} onChange={this.onTabChange} aria-label='Info Tabs'>
                        <PrimaryTab label='SUMMARY' />
                        <PrimaryTab label='DIVISION INFO' />
                        <PrimaryTab label='ELECTRICAL POINT' />
                        <PrimaryTab label='LOCATION' />
                        <PrimaryTab label='CONNECTIONS' />
                        <PrimaryTab label='INSTALLATION AUDIT' />
                        <PrimaryTab label='INSPECTION AUDIT' />
                    </PrimaryTabs>
                </AppBar>
                <div className={'fdc flx1 hfill'}>
                    {
                        pumpingStation && session &&
                        <TabViews index={tabIndex}>
                            <PumpingStationSummary session={session} pumpingStation={pumpingStation} isLoading={isLoadingPumpingStations} />
                            <PumpingStationDivision session={session} pumpingStation={pumpingStation} isLoading={isLoadingPumpingStations} />
                            <PumpingStationTransformerView pumpingStation={pumpingStation} />
                            <PumpingStationLocation session={session} pumpingStation={pumpingStation} isLoading={isLoadingPumpingStations} />
                            <PumpingStationConnections session={session} pumpingStation={pumpingStation} isLoading={isLoadingPumpingStations} />
                            <PumpingStationAudit session={session} pumpingStation={pumpingStation} isLoading={isLoadingPumpingStations} />
                            <PumpingStationInspectionAudit session={session} pumpingStation={pumpingStation} isLoading={isLoadingPumpingStations} />
                        </TabViews>
                    }
                </div>
                {
                    !!pumpingStation && (
                        <ConfirmDialog open={showDelete} title={'Confirm'}
                            message={`${(typeof pumpingStation.isActive === 'undefined' || pumpingStation.isActive) ? 'Deactivate' : 'Activate'} Pumping Station ${pumpingStation.code}`}
                            onClose={this.onDelete} transition={Transitions.Up} />
                    )
                }
            </Dialog>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        pumpingStation: state.pumpingStation.selectedPumpingStation,
        isLoadingPumpingStations: state.pumpingStation.loading,
        session: state.auth.session,
    };
};

export default connect(
    mapStateToProps,
)(PumpingStationInfo);
